<div class="container color">
  <form class="rower" [formGroup]="form">
    <div class="row">
      <h2 class="finalSetUpLable" style="text-align: center" *ngIf="!isInsight">
        Final Setup
      </h2>
      <div class="padding-10"></div>
      <div class="col-md-5">
        <!-- visible to all operators but if logged-in as service buyer then visibility depends on the selected buyers config.
        it should also be visible if a survey has unique links uploaded but the config was disabled later. -->
        <div
          *ngIf="
            (userType === 'operator' && !loggedInAsServiceBuyer) ||
              form.value.uniqBuyerEntryLinkFlag;
            else uniqueBuyerEntryLinkContent
          "
        >
          <ng-container
            *ngTemplateOutlet="uniqueBuyerEntryLinkTemplate"
          ></ng-container>
        </div>
        <ng-template #uniqueBuyerEntryLinkContent>
          <div *psUiConfigEnabled="'uniqBuyerEntryLink'">
            <ng-container
              *ngTemplateOutlet="uniqueBuyerEntryLinkTemplate"
            ></ng-container>
          </div>
        </ng-template>

        <ng-template #uniqueBuyerEntryLinkTemplate>
          <section class="sectionMargin">
            <label class="text-uppercase buyerEntryLinkLable"
              >Unique Buyer Entry Links</label
            >
            <div class="setting-info">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span>These are Unique Buyer Entry Links <br /></span>
                Please use only CSV, XLS, XLSX file
              </p>
            </div>
            <div class="d-flex align-items-center sectionMargin">
              <span class="selectBtn">off</span>
              <ps-ui-slider
                id="entryLinks"
                (selectedChange)="setEntryLinkFlag()"
                [selected]="form.value.uniqBuyerEntryLinkFlag"
                [disabled]="isBuyerLinkSliderDisabled"
                [ngClass]="{
                  slider_on: this.form.controls.uniqBuyerEntryLinkFlag
                }"
                psUiActivityLog
                logMessage="UNIQUE_BUYER_ENTRY_LINKS_STATUS"
                logListenEvent="change"
                [logSurveyId]="surveyId"
                [logMetadata]="{
                  from: featureStatus(!form.value.uniqBuyerEntryLinkFlag),
                  to: featureStatus(form.value.uniqBuyerEntryLinkFlag)
                }"
              >
              </ps-ui-slider>
              <span class="selectBtn select-btn-on">on</span>
              <div *ngIf="!buyerEntryLinkUploaded">
                <input
                  #fileUpload
                  hidden
                  type="file"
                  class="file-upload"
                  accept=".xlsx,.xls,.csv"
                  (change)="uploadMappings($event)"
                  psUiGtagEvent
                  trackOn="change"
                  action="unique_links_entry"
                  category="Survey_Launch_Edit"
                  [params]="{ event_label: 'Unique Entry Links' }"
                  psUiActivityLog
                  logMessage="UNIQUE_BUYER_ENTRY_LINKS_UPLOAD"
                  logListenEvent="change"
                  [logSurveyId]="surveyId"
                />
                <button
                  class="textUnd"
                  *ngIf="form.value.uniqBuyerEntryLinkFlag"
                  type="button"
                  class="px-1 btn-view btn btn-link upload-button"
                  (click)="fileUpload.value = ''; fileUpload.click()"
                >
                  Upload a file
                </button>
                <span *ngIf="form.value.uniqBuyerEntryLinkFlag">|</span>
                <a
                  class="textUnd"
                  type="button"
                  class="px-1 btn-view btn btn-link download-button"
                  (click)="downloadSampleUniqBuyerEntryLink()"
                >
                  Download Template
                </a>
              </div>
              <div *ngIf="buyerEntryLinkUploaded">
                <a
                  class="textUnd"
                  href="javascript:void(0);"
                  (click)="viewBuyerLinks()"
                  class="px-1 btn-view"
                  >View Entry Links</a
                >
                <span>|</span>
                <a
                  class="textUnd"
                  href="javascript:void(0);"
                  (click)="clearUploadedBuyerEntryLinks()"
                  class="px-1 btn-view"
                  psUiActivityLog
                  logMessage="UNIQUE_BUYER_ENTRY_LINKS_CLEAR"
                  logListenEvent="click"
                  [logSurveyId]="surveyId"
                  >Clear Upload</a
                >
              </div>
            </div>
            <div
              *ngIf="
                (isTraditionalMcSurvey || isMcSvpSurvey) &&
                form.value.uniqBuyerEntryLinkFlag
              "
              class="d-flex"
            >
              <input
                id="sameFileEntryLinks"
                type="checkbox"
                class="form-check-input"
                (change)="onSameFileEntryLinksCheckChange()"
                [checked]="this.form.value.isSameFileEntryLinksChecked"
              />
              <label
                for="sameFileEntryLinks"
                class="lbl-view same-settings-check-txt"
              >
                {{ SAME_SETTINGS_TEXT.UNIQUE_BUYER_ENTRY_LINKS }}
              </label>
            </div>
          </section>
        </ng-template>

        <ps-ui-nightcrawler
          *ngIf="enableNightcrawler && !isSurveySyncedOnNC"
          [surveyId]="surveyId"
          [launchSurveyForm]="form"
          [(ncSettings)]="ncSettings"
          [(isSurveySyncedOnNC)]="isSurveySyncedOnNC"
          (generateEntryLink)="generateEntryLink($event)"
          (updatePayload)="updatePayload()"
        >
        </ps-ui-nightcrawler>
        <ng-container
          *ngIf="
            !enableNightcrawler || (enableNightcrawler && isSurveySyncedOnNC)
          "
        >
          <div
            class="edit-redirect-link"
            *ngIf="enableNightcrawler && isSurveySyncedOnNC"
          >
            <a href="javascript:void(0);" (click)="isSurveySyncedOnNC = false"
              >Edit Redirect Settings <i class="fa fa-edit"></i
            ></a>
          </div>
          <label
            >LIVE URL *
            <div
              class="setting-info infos"
              *ngIf="!form.value.uniqBuyerEntryLinkFlag"
            >
              <i
                class="fa fa-warning warningInfo"
                *ngIf="warningFlg"
                aria-hidden="true"
              ></i>
              <p *ngIf="showTransIdWarningMsg">
                <span>{{ form.controls.liveWarningMsg.value }}</span>
              </p>
              <p *ngIf="showNonHttpsWarningMsg">
                <span>{{ form.controls.nonHttpsWarningMsg.value }}</span>
              </p>
            </div>
          </label>
          <section class="informd sectionMargin">
            <input
              type="text"
              id="live_url"
              (keyup)="setLiveUrlInfo(form.value.live_url)"
              class="form-control"
              formControlName="live_url"
              [attr.disabled]="shouldDisableLiveTestUrlField ? '' : null"
            />
            <div class="setting-info inform">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span>{{ form.controls.liveUrlTT.value }}</span>
              </p>
            </div>
          </section>
          <div *ngIf="isTraditionalMcSurvey || isMcSvpSurvey" class="d-flex">
            <input
              id="sameBuyerUrlSettings"
              type="checkbox"
              class="form-check-input"
              (change)="
                toggleSameSettingsCheck(
                  'isSameBuyerUrlChecked',
                  !this.form.value.isSameBuyerUrlChecked
                )
              "
              [checked]="this.form.value.isSameBuyerUrlChecked"
              [disabled]="form.value.uniqBuyerEntryLinkFlag"
            />
            <label
              for="sameBuyerUrlSettings"
              class="lbl-view same-settings-check-txt"
            >
              {{
                isMcSvpSurvey
                  ? SAME_SETTINGS_TEXT.SINGLE_VIEW.URL_FEATURES
                  : SAME_SETTINGS_TEXT.TRADITIONAL_VIEW.URL_FEATURES
              }}
            </label>
          </div>
          <label
            >TEST URL
            <div class="setting-info infos">
              <i
                class="fa fa-warning warningInfo"
                *ngIf="warningTestFlg"
                aria-hidden="true"
              ></i>
              <p>
                <span>{{ form.controls.testWarningMsg.value }}</span>
              </p>
            </div>
          </label>
          <section class="informd sectionMargin">
            <input
              type="text"
              id="test_url"
              (keyup)="changeTestUrlInfo(form.value.test_url)"
              class="form-control"
              formControlName="test_url"
              [attr.disabled]="shouldDisableLiveTestUrlField ? '' : null"
            />
            <div class="setting-info inform">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span>{{ form.controls.testUrlTT.value }} </span>
              </p>
            </div>
          </section>

          <div>
            <button
              type="button"
              class="btn btn-default testBtn"
              (click)="openTab(form.value.test_ps_survey_entry_link)"
            >
              TEST
            </button>
          </div>
        </ng-container>

        <section class="redirect">
          <div *psUiConfigEnabled="'enableUrlTranfrmUsr'">
            <div
              [ngClass]="
                form.value.url_transform
                  ? 'disable-automatic-red'
                  : 'disable-automatic'
              "
            >
              Disable Automatic Variable Mapping
            </div>
            <input
              class="urltransform_check form-check-input"
              type="checkbox"
              formControlName="url_transform"
              (change)="checkDisableAutoMapping(form.value.url_transform)"
            />
          </div>
          <div class="padding-10"></div>
          <div>
            <label>REDIRECT LINKS </label>
            <br />
            <a href="buyerRedirectGuide" target="_blank"
              >See links and instructions</a
            >
          </div>
          <div class="padding10"></div>
        </section>
        <div class="padding-10"></div>
        <section class="redirect padding-added">
          <div>
            <div style="display: flex">
              <label>BILLING</label><br />
              <span
                *ngIf="billingRules?.mandatory || enableMandatoryBillingNumber"
                >*</span
              >
              <ps-ui-billing-number-tooltip
                [rules]="billingRules$ | async"
              ></ps-ui-billing-number-tooltip>
            </div>
            <input
              type="text"
              class="surveyBilling"
              id="billing"
              placeholder="Billing number"
              (keyup)="
                validateAndRemoveSpacesFromBillingNumber(form.value.billing_id)
              "
              (focusout)="validateBillingCode()"
              formControlName="billing_id"
            />
            <p *ngIf="billingRules">
              {{ 'Example: ' + billingRules.example }}
            </p>
          </div>
          <div *ngIf="isTraditionalMcSurvey || isMcSvpSurvey" class="d-flex">
            <input
              id="sameBillingSettings"
              type="checkbox"
              class="form-check-input"
              (change)="
                toggleSameSettingsCheck(
                  'isSameBillingSurveyPoChecked',
                  !this.form.value.isSameBillingSurveyPoChecked
                )
              "
              [disabled]="isMcSvpSurvey || !this.form.value.billing_id?.length"
              [checked]="this.form.value.isSameBillingSurveyPoChecked"
            />
            <label
              for="sameBillingSettings"
              class="lbl-view same-settings-check-txt"
            >
              {{
                isMcSvpSurvey
                  ? SAME_SETTINGS_TEXT.SINGLE_VIEW.BILLING_ID_FEATURE
                  : SAME_SETTINGS_TEXT.TRADITIONAL_VIEW.BILLING_ID_FEATURE
              }}
            </label>
            <ng-container
              *ngTemplateOutlet="sameSettingsTooltip"
            ></ng-container>
          </div>
          <div class="padding-10"></div>
          <ng-template #buyerClientTemplate>
            <label>BUYER CLIENT</label><br />
            <input
              type="text"
              id="surveyBilling"
              class="form-control"
              (keyup)="
                updatePayload({ survey_client: form.value.survey_client })
              "
              formControlName="survey_client"
            />
          </ng-template>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin';
              else buyerClientNoContent
            "
          >
            <ng-container
              *ngTemplateOutlet="buyerClientTemplate"
            ></ng-container>
          </div>
          <ng-template #buyerClientNoContent>
            <div *psUiConfigEnabled="'buyerClient'">
              <ng-container
                *ngTemplateOutlet="buyerClientTemplate"
              ></ng-container>
            </div>
          </ng-template>

          <div class="padding-10"></div>
        </section>
      </div>

      <div class="col-md-5 letter">
        <!-- AIDA COMPONENT -->
        <ng-template [ngIf]="aidaEligibility$ | async" let-aidaEligibility>
          <div *ngIf="aidaEligibility">
            <ps-ui-ai-delivery-assistant
              [initialEligibility]="aidaEligibility?.eligibility"
              [surveyFeatures]="aidaEligibility?.features"
              [surveyPayload]="surveyPayload"
              [aidaQuotasForSelection]="qbpSelectionQuotas"
              [surveyDetails]="surveyDatails"
              [form]="form"
            ></ps-ui-ai-delivery-assistant>
          </div>
        </ng-template>

        <section
          class="section-dq-settings"
          *ngIf="showDQBattery || enableProjectLevelDataQuality"
        >
          <label class="section launchLable"> Data Quality</label>
          <div *ngIf="isMcSvpSurvey" class="d-flex">
            <input
              id="sameDqSettings"
              type="checkbox"
              class="form-check-input"
              (change)="
                toggleSameSettingsCheck(
                  'isSameDqSettingsChecked',
                  !form.value.isSameDqSettingsChecked
                )
              "
              [disabled]="isMcSvpSurvey"
              [checked]="form.value.isSameDqSettingsChecked"
            />
            <label
              for="sameDqSettings"
              class="lbl-view same-settings-check-txt"
            >
              {{ SAME_SETTINGS_TEXT.SINGLE_VIEW.DATA_QUALITY_FEATURES }}
            </label>
            <ng-container
              *ngTemplateOutlet="sameSettingsTooltip"
            ></ng-container>
          </div>
          <ng-container>
            <ng-template #dqSettingsTemplate>
              <div class="sectionMargin data-quality-label">
                <label>PURESCORE FILTER</label>
                <div class="d-flex align-items-center">
                  <span class="selectBtn">off</span>
                  <ps-ui-slider
                    id="pureScorefilter"
                    [selected]="form.value.dq_settings.purescore_filter_enabled"
                    psUiGtagEvent
                    trackOn="change"
                    (selectedChange)="
                      updateDqSetting('purescore_filter_enabled', $event)
                    "
                    action="pure_score_filter"
                    category="Survey_Launch_Edit"
                    [params]="{ event_label: 'Purescore Filter' }"
                    psUiActivityLog
                    logMessage="DATA_QUALITY_FILTER"
                    logListenEvent="change"
                    [logSurveyId]="surveyId"
                    [logMetadata]="{
                      from: featureStatus(
                        !form.value.dq_settings.purescore_filter_enabled
                      ),
                      to: featureStatus(
                        form.value.dq_settings.purescore_filter_enabled
                      )
                    }"
                  >
                  </ps-ui-slider>
                  <span class="selectBtn">on</span>
                </div>
              </div>
              <div class="sectionMargin data-quality-label">
                <label>FP BASED DEVICE DUPLICATION CHECKED</label>
                <div class="d-flex align-items-center">
                  <span class="selectBtn">off</span>
                  <ps-ui-slider
                    id="fpBasedDdc"
                    [selected]="form.value.dq_settings.fp_device_check"
                    psUiGtagEvent
                    trackOn="change"
                    (selectedChange)="
                      updateDqSetting('fp_device_check', $event)
                    "
                    action="fb_based_device_duplication_checked"
                    category="Survey_Launch_Edit"
                    [params]="{
                      event_label: 'FP Based Device Duplication Checked'
                    }"
                    psUiActivityLog
                    logMessage="DATA_QUALITY_DEVICE_DUPLICATION"
                    logListenEvent="change"
                    [logSurveyId]="surveyId"
                    [logMetadata]="{
                      from: featureStatus(
                        !form.value.dq_settings.fp_device_check
                      ),
                      to: featureStatus(form.value.dq_settings.fp_device_check)
                    }"
                  >
                  </ps-ui-slider>
                  <span class="selectBtn">on</span>
                </div>
              </div>
              <div class="sectionMargin data-quality-label">
                <label>FP BASED FRAUD CHECK</label>
                <div class="d-flex align-items-center">
                  <span class="selectBtn">off</span>
                  <ps-ui-slider
                    id="fpBasedDdc"
                    [selected]="form.value.dq_settings.fp_fraud_check"
                    psUiGtagEvent
                    trackOn="change"
                    (selectedChange)="updateDqSetting('fp_fraud_check', $event)"
                    action="fp_based_fraud_check"
                    category="Survey_Launch_Edit"
                    [params]="{ event_label: 'FP Based Fraud Check' }"
                    psUiActivityLog
                    logMessage="DATA_QUALITY_BASED_FRAUD"
                    logListenEvent="change"
                    [logSurveyId]="surveyId"
                    [logMetadata]="{
                      from: featureStatus(
                        !form.value.dq_settings.fp_fraud_check
                      ),
                      to: featureStatus(form.value.dq_settings.fp_fraud_check)
                    }"
                  >
                  </ps-ui-slider>
                  <span class="selectBtn">on</span>
                </div>
              </div>
            </ng-template>

            <div *ngIf="enableProjectLevelDataQuality">
              <ng-container
                *ngTemplateOutlet="dqSettingsTemplate"
              ></ng-container>
            </div>
          </ng-container>

          <section *ngIf="showDQBattery">
            <div>
              <ng-container
                *ngTemplateOutlet="DQBatteryTemplate"
              ></ng-container>
            </div>

            <ng-template #DQBatteryTemplate>
              <div class="sectionMargin">
                <label>DATA QUALITY BATTERY</label>
                <div class="setting-info">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                  <p>
                    <span>
                      Turn on Data Quality Battery as part of survey
                      pre-screener
                    </span>
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <div>
                    <span class="selectBtn">off </span>
                    <ps-ui-slider
                      (selectedChange)="changeSurveyDQEnabled($event)"
                      [disabled]="!showDQBattery"
                      [selected]="form.value.is_dq_enable"
                      psUiActivityLog
                      logMessage="DATA_QUALITY_BATTERY"
                      logListenEvent="change"
                      [logSurveyId]="surveyId"
                      [logMetadata]="{
                        from: featureStatus(!form.value.is_dq_enable),
                        to: featureStatus(form.value.is_dq_enable)
                      }"
                    >
                    </ps-ui-slider>
                    <span class="selectBtn">on</span>
                  </div>
                  <br />
                </div>
              </div>
            </ng-template>
          </section>
        </section>

        <section class="section-launch">
          <label class="section launchLable"> Launch </label>

          <div *ngIf="isMcSvpSurvey" class="d-flex">
            <input
              id="sameLaunchSettings"
              type="checkbox"
              class="form-check-input"
              (change)="
                toggleSameSettingsCheck(
                  'isSameLaunchSettingsChecked',
                  !form.value.isSameLaunchSettingsChecked
                )
              "
              [disabled]="isMcSvpSurvey"
              [checked]="form.value.isSameLaunchSettingsChecked"
            />
            <label
              for="sameLaunchSettings"
              class="lbl-view same-settings-check-txt"
            >
              {{ SAME_SETTINGS_TEXT.SINGLE_VIEW.LAUNCH_FEATURES }}
            </label>
            <ng-container
              *ngTemplateOutlet="sameSettingsTooltip"
            ></ng-container>
          </div>

          <ng-container
            *ngIf="isEnableMarginMaxForBuyer && userType === 'operator'"
          >
            <div
              class="sectionMargin"
              [ngClass]="{ 'aida-enabled': form.value.is_aida_enabled }"
            >
              <label>MARGIN MAX</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span>
                    Margin Max will use Automation to update SCPI based on a
                    project’s pace.
                  </span>
                </p>
              </div>
              <ps-ui-aida-feature-unavailable-tooltip
                [isAidaEnabled]="form.value.is_aida_enabled"
                class="ms-2"
              ></ps-ui-aida-feature-unavailable-tooltip>

              <div class="d-flex align-items-center">
                <span class="selectBtn">off</span>
                <ps-ui-slider
                  id="marginMax"
                  [ngClass]="{
                    slider_on: form.controls.is_enable_margin_max
                  }"
                  (selectedChange)="updateMarginMax($event)"
                  [(selected)]="form.value.is_enable_margin_max"
                  [disabled]="
                    !surveyDatails.is_enable_margin_max ||
                    !!form.value.is_aida_enabled
                  "
                >
                </ps-ui-slider>
                <span class="selectBtn">on</span>
              </div>
            </div>
          </ng-container>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin' ||
                userDetails.operatorAcssLvls === 'serviceOperator';
              else basicTokenContent
            "
          >
            <ng-container *ngTemplateOutlet="basicTokenTemplate"></ng-container>
          </div>
          <ng-template #basicTokenContent>
            <div *psUiConfigEnabled="'enableBasicToken'">
              <ng-container
                *ngTemplateOutlet="basicTokenTemplate"
              ></ng-container>
            </div>
          </ng-template>

          <ng-template #basicTokenTemplate>
            <div class="sectionMargin">
              <label>LINK SECURITY - Basic</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  The 'Basic Token' secures your links on a survey level,
                  preventing the most basic form of redirection fraud/ghost
                  completes.<br />
                  While it is better to implement a hash based signature, the
                  basic token provides some amount of security.<br />
                  If you select 'Basic Token' you are required to successfully
                  test your survey for a complete before launch.<br />
                  This token is unique per survey, and will not be reused.
                </p>
              </div>
              <div class="d-flex align-items-center">
                <span class="selectBtn">off</span>
                <ps-ui-slider
                  id="basic_token"
                  (selectedChange)="updateLinkSecurity($event)"
                  [selected]="form.value.basic_token.enable"
                >
                </ps-ui-slider>
                <span class="selectBtn">on</span>
              </div>
              <div *ngIf="this.form.value.basic_token.enable">
                <div class="padding-5"></div>
                <label>Basic Token</label>
                <br />
                <div class="basicTokenContainer">
                  <div
                    formGroupName="basic_token"
                    [ngClass]="{
                      editable: this.notEditableBasicToken === false
                    }"
                    class="infoInput"
                  >
                    <input
                      class="form-control survey-style width100"
                      type="text"
                      placeholder="Basic Token"
                      [attr.disabled]="
                        this.notEditableBasicToken === true ? true : null
                      "
                      id="basicToken"
                      #basicToken
                      formControlName="value"
                    />
                    <i
                      *ngIf="this.notEditableBasicToken"
                      (click)="handleEditBasicToken(false)"
                      class="fa fa-edit showOnHover"
                    ></i>
                    <i
                      *ngIf="!this.notEditableBasicToken"
                      (click)="handleEditBasicToken(true)"
                      class="fa fa-close iconRed"
                    ></i>
                    <i
                      *ngIf="!this.notEditableBasicToken"
                      (click)="updateLinkSecurity()"
                      class="fa fa-check"
                    ></i>
                  </div>
                  <i
                    (click)="copyToClipboard(this.form.value.basic_token.value)"
                    class="fa fa-copy"
                  ></i>
                  <span *ngIf="this.showSuccessTooltip" class="custom-tooltip"
                    >Basic Token Copied!</span
                  >
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template #scheduledLaunchTemplate>
            <div
              class="sectionMargin schedule-launch-label"
              enableScheduledLaunch
            >
              <label>SCHEDULED LAUNCH</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span>
                    This feature gives you the ability to schedule the field
                    time/launch time of a survey.
                  </span>
                  <br />
                  <span>
                    NOTE: That if you save this project as a DRAFT, you will
                    need to re-enter the launch date. To save and apply the
                    SCHEDULED LAUNCH date/time, you need to click on FINALIZE &
                    LAUNCH.
                  </span>
                </p>
              </div>
              <div class="d-flex align-items-center">
                <span class="selectBtn">off</span>
                <ps-ui-slider
                  id="scheduleLaunch"
                  (selectedChange)="updateScheduleaunchFlag($event)"
                  [selected]="form.value.schedule_launch.enable"
                  [disabled]="scheduleLaunchSlideDisable"
                  psUiActivityLog
                  logMessage="SCHEDULED_LAUNCH_STATUS"
                  logListenEvent="change"
                  [logSurveyId]="surveyId"
                  [logMetadata]="{
                    from: featureStatus(!form.value.schedule_launch.enable),
                    to: featureStatus(form.value.schedule_launch.enable)
                  }"
                >
                </ps-ui-slider>
                <span class="selectBtn">on</span>
              </div>

              <div
                *ngIf="this.form.value.schedule_launch.enable"
                formGroupName="scheduledLaunchDetails"
              >
                <div class="padding-5"></div>
                <label>SELECT LAUNCH DATE</label>
                <br />
                <input
                  class="country-dropdown box-s"
                  type="text"
                  name="daterangeInput"
                  [options]="datapickerOptions"
                  daterangepicker
                  (selected)="selectScheduledLaunchDate($event)"
                  placeholder="Select Date"
                  [disabled]="scheduleLaunchDisable"
                  formControlName="date"
                />
              </div>

              <div
                class="select-hours-list"
                *ngIf="this.form.value.schedule_launch.enable"
                formGroupName="scheduledLaunchDetails"
              >
                <label>SELECT LAUNCH TIME</label>
                <div class="row">
                  <div class="col-md-2 form-group">
                    <ps-ui-select-dropdown
                      class="btn schedule-launch-dropdown"
                      [enableSearch]="false"
                      [labelNone]="'HH'"
                      [dropdownItems]="hours"
                      [field]="'key'"
                      (selectedItem)="selectHours($event)"
                      [disabled]="scheduleLaunchDisable"
                      [label]="form.value.scheduledLaunchDetails?.hours"
                    >
                    </ps-ui-select-dropdown>
                  </div>

                  <div class="col-md-2 form-group">
                    <ps-ui-select-dropdown
                      class="btn schedule-launch-dropdown"
                      [enableSearch]="false"
                      [labelNone]="'MM'"
                      [dropdownItems]="minutes"
                      [field]="'key'"
                      (selectedItem)="selectMinutes($event)"
                      [disabled]="scheduleLaunchDisable"
                      [label]="form.value.scheduledLaunchDetails?.minutes"
                    >
                    </ps-ui-select-dropdown>
                  </div>

                  <div class="col-md-8 form-group">
                    <ps-ui-select-dropdown
                      class="btn schedule-launch-dropdown"
                      id="timezone_position"
                      [labelNone]="'Select Timezone'"
                      labelAlignment="start"
                      [dropdownItems]="tzNames"
                      [field]="'name'"
                      (selectedItem)="selectTimeZone($event)"
                      [disabled]="scheduleLaunchDisable"
                      [label]="form.value.scheduledLaunchDetails?.timezone"
                    >
                    </ps-ui-select-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin' ||
                userDetails.operatorAcssLvls === 'serviceOperator';
              else scheduledLaunchContent
            "
          >
            <ng-container
              *ngTemplateOutlet="scheduledLaunchTemplate"
            ></ng-container>
          </div>
          <ng-template #scheduledLaunchContent>
            <div *psUiConfigEnabled="'enableScheduledLaunch'">
              <ng-container
                *ngTemplateOutlet="scheduledLaunchTemplate"
              ></ng-container>
            </div>
          </ng-template>
          <div
            class="sectionMargin"
            [ngClass]="{ 'aida-enabled': form.value.is_aida_enabled }"
          >
            <label>SOFT LAUNCH</label>
            <div class="setting-info">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span
                  >Soft launch will pause the survey after the estimated number
                  of Buyer Survey Starts has been reached. This number is based
                  on your stated Incidence Rate.If the number of completes is
                  met before this goal is reached,the survey will be paused. The
                  survey may pause due to performance before the soft launch is
                  met.
                </span>
              </p>
            </div>
            <ps-ui-aida-feature-unavailable-tooltip
              [isAidaEnabled]="form.value.is_aida_enabled"
              class="ms-2"
            ></ps-ui-aida-feature-unavailable-tooltip>
            <div class="d-flex align-items-center">
              <span class="selectBtn">off</span>
              <ps-ui-slider
                id="softLaunch"
                (selectedChange)="updateSoftLaunch($event)"
                [selected]="form.value.softLaunch"
                [disabled]="
                  softLaunchSlideDisable || !!form.value.is_aida_enabled
                "
                psUiGtagEvent
                trackOn="change"
                action="soft_launch"
                category="Survey_Launch_Edit"
                [params]="{ event_label: 'Soft Launch' }"
                psUiActivityLog
                logMessage="SOFT_LAUNCH_STATUS"
                logListenEvent="change"
                [logSurveyId]="surveyId"
                [logMetadata]="{
                  from: featureStatus(!form.value.softLaunch),
                  to: featureStatus(form.value.softLaunch)
                }"
              >
              </ps-ui-slider>
              <span class="selectBtn">on</span>
              <div class="spacing spacing-completes">
                <label for="" class="me-3">Completes:</label>
                <span
                  class="qty-holder inputlaunchQty"
                  style="padding-bottom: 2px"
                  >#</span
                >
                <input
                  type="number"
                  e2e-data="soft-launch-completes"
                  class="inputlaunchQty me-2"
                  placeholder="200"
                  formControlName="launchquantity"
                  (input)="launchquantityChange()"
                  [disabled]="softLaunchDisable || !!form.value.is_aida_enabled"
                />

                <input
                  type="number"
                  class="inputlaunchQty"
                  placeholder="20"
                  formControlName="launchpercentile"
                  (input)="launchpercentileChange()"
                  [disabled]="softLaunchDisable || !!form.value.is_aida_enabled"
                />
                <span
                  class="percentage-holder inputlaunchQty"
                  style="padding-bottom: 2px"
                  >%</span
                >
              </div>
            </div>
          </div>

          <div class="sectionMargin" *psUiConfigEnabled="'enableModularSurvey'">
            <label>MODULAR LAUNCH</label>
            <div class="setting-info">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span
                  >Project is restricted to JDPA. This will allow the buyer to
                  launch a project that has multi-steps project - (Core,
                  Modular, Long-run)
                </span>
              </p>
            </div>
            <div class="d-flex align-items-center">
              <span class="selectBtn">off</span>
              <ps-ui-slider
                id="modular-toggle"
                (selectedChange)="toggleModularSurvey($event)"
                [selected]="form.value.is_modular_survey"
                psUiGtagEvent
                trackOn="change"
                action="modular_launch"
                category="Survey_Launch_Edit"
                [params]="{ event_label: 'MODULAR LAUNCH' }"
                psUiActivityLog
                logMessage="MODULAR_LAUNCH_STATUS"
                logListenEvent="change"
                [logSurveyId]="surveyId"
                [logMetadata]="{
                  from: featureStatus(!form.value.is_modular_survey),
                  to: featureStatus(form.value.is_modular_survey)
                }"
              >
              </ps-ui-slider>
              <span class="selectBtn">on</span>
            </div>
          </div>

          <div
            class="sectionMargin"
            *ngIf="
              enableSupplierAllocationThrottling ||
              surveyDatails.supplier_allocation_throttle
            "
          >
            <label>SUPPLIER ALLOCATION THROTTLE</label>
            <div class="setting-info">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span
                  >This feature will limit the supplier delivery to the clicks
                  estimated to be needed to achieve the Suppliers’ Allocation.
                </span>
              </p>
            </div>
            <div class="d-flex align-items-center">
              <span class="selectBtn">off</span>
              <ps-ui-slider
                id="supplier-allocation-throttle"
                (selectedChange)="toggleSupAllocationThrottle($event)"
                [selected]="form.value.supplier_allocation_throttle"
                psUiGtagEvent
                trackOn="change"
                action="supplier_allocation_throttle"
                category="Survey_Launch_Edit"
                [params]="{ event_label: 'SUPPLIER ALLOCATION THROTTLE' }"
              >
              </ps-ui-slider>
              <span class="selectBtn">on</span>
            </div>
          </div>
        </section>

        <section class="section-quota-features">
          <label class="section launchLable"> Quota Features </label>

          <div *ngIf="isMcSvpSurvey" class="d-flex">
            <input
              id="sameQuotaSettings"
              type="checkbox"
              class="form-check-input"
              (change)="
                toggleSameSettingsCheck(
                  'isSameQuotaSettingsChecked',
                  !form.value.isSameQuotaSettingsChecked
                )
              "
              [disabled]="isMcSvpSurvey"
              [checked]="form.value.isSameQuotaSettingsChecked"
            />
            <label
              for="sameQuotaSettings"
              class="lbl-view same-settings-check-txt"
            >
              {{ SAME_SETTINGS_TEXT.SINGLE_VIEW.QUOTA_FEATURES }}
            </label>
            <ng-container
              *ngTemplateOutlet="sameSettingsTooltip"
            ></ng-container>
          </div>

          <ng-template #quotaThrottlingTemplate>
            <div class="sectionMargin">
              <label>ENABLE QUOTA THROTTLING</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span>By switching quota throttling to: <br /> </span>
                  <span>
                    "On", PureSpectrum will restrict the flow of traffic to
                    quotas so that the number of respondents does not exceed the
                    number of available completes.
                  </span>
                  <br />
                  <span>
                    "Off", PureSpectrum will send a metered amount of
                    respondents that is greater than available completes. The
                    extent of the metering will be based on the conversion rate
                    of the project and will aid help to accommodate for
                    Drop-Offs and low incidence studies.
                  </span>
                  <br />
                  <span>
                    PLEASE NOTE: The survey tool you use should be taken into
                    consideration to determine the best strategy for you.
                  </span>
                </p>
              </div>
              <div class="d-flex align-items-center">
                <span class="selectBtn">off</span>
                <ps-ui-slider
                  id="quota_throttling"
                  (selectedChange)="updateQuotaThrottling()"
                  [selected]="form.value.quota_throttling"
                  psUiGtagEvent
                  trackOn="change"
                  action="quota_throttling"
                  category="Survey_Launch_Edit"
                  [params]="{ event_label: 'Quota Throttling' }"
                >
                </ps-ui-slider>
                <span class="selectBtn">on</span>
              </div>
            </div>
          </ng-template>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin' ||
                userDetails.operatorAcssLvls === 'serviceOperator';
              else quotaThrottlingContent
            "
          >
            <ng-container
              *ngTemplateOutlet="quotaThrottlingTemplate"
            ></ng-container>
          </div>
          <ng-template #quotaThrottlingContent>
            <div *psUiConfigEnabled="'quotaThrottling'">
              <ng-container
                *ngTemplateOutlet="quotaThrottlingTemplate"
              ></ng-container>
            </div>
          </ng-template>
          <ng-template #feotTemplate>
            <div
              class="sectionMargin"
              formGroupName="feot"
              [ngClass]="{ 'aida-enabled': form.value.is_aida_enabled }"
            >
              <label>FIELD EVENLY OVER TIME</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span
                    >FEOT does not guarantee a goal is met, but it limits the
                    number of completes allowed each day for a quota to ensure
                    that the maximum number of daily completes won't exceed the
                    same amount for every day the project is in the field.</span
                  >
                </p>
              </div>
              <ps-ui-aida-feature-unavailable-tooltip
                [isAidaEnabled]="form.value.is_aida_enabled"
                class="ms-2"
              ></ps-ui-aida-feature-unavailable-tooltip>
              <div class="completesPerDaySection">
                <div class="d-flex align-items-center">
                  <span class="selectBtn">off</span>
                  <ps-ui-slider
                    id="FEOT"
                    (selectedChange)="showFeotFields($event)"
                    [selected]="form.value.is_feot_enabled"
                    [disabled]="
                      fieldOverTimeDisable || !!form.value.is_aida_enabled
                    "
                    psUiGtagEvent
                    trackOn="change"
                    action="feot"
                    category="Survey_Launch_Edit"
                    [params]="{ event_label: 'FEOT' }"
                    psUiActivityLog
                    logMessage="FEOT_STATUS"
                    logListenEvent="change"
                    [logSurveyId]="surveyId"
                    [logMetadata]="{
                      from: featureStatus(!form.value.is_feot_enabled),
                      to: featureStatus(form.value.is_feot_enabled),
                      completes: feotFields.feotQuantity,
                      kind: isClickSurvey ? 'click' : 'complete',
                      window:
                        (isCustomPacingText ? feotPaceSingular() : 'day')
                        | lowercase,
                      total: feotFields.feotRemainingTime
                    }"
                  >
                  </ps-ui-slider>
                  <span class="selectBtn">on</span>
                </div>
                <div class="spacing">
                  <span class="me-2 completesPerDayNumbers">
                    {{ feotFields.feotQuantity }}
                  </span>
                  <span class="completesPerDayLabel" for="">
                    {{ isClickSurvey ? 'click' : 'complete'
                    }}{{ feotPacePlural() }} per
                    {{
                      (isCustomPacingText ? feotPaceSingular() : 'day')
                        | lowercase
                    }}
                    for
                  </span>
                  <span class="ms-2 me-2 completesPerDayNumbers">
                    {{ feotFields.feotRemainingTime }}
                  </span>
                  <span class="completesPerDayLabel">
                    remaining
                    {{
                      (isCustomPacingText
                        ? feotPaceFormat(
                            undefined,
                            feotFields.feotRemainingTime
                          )
                        : 'days'
                      ) | lowercase
                    }}
                    in field.
                  </span>
                </div>
              </div>
              <ps-ui-accordion [closeOthers]="false" [arrowToggleOnly]="false">
                <ps-ui-accordion-section
                  [isExpanded]="form.value.is_feot_enabled"
                  class="no-header no-border"
                >
                  <div class="feotDaily">
                    <span class="selectBtn">Daily</span>
                    <ps-ui-slider
                      (selectedChange)="updateFeotCustomPacing($event)"
                      [selected]="form.value.feot.is_custom"
                      [disabled]="!form.value.is_feot_enabled"
                    >
                    </ps-ui-slider>
                    <span class="selectBtn">Custom</span>
                    <br />
                  </div>
                  <ps-ui-accordion
                    [closeOthers]="false"
                    [arrowToggleOnly]="false"
                  >
                    <ps-ui-accordion-section
                      [isExpanded]="
                        form.value.feot.is_custom && form.value.is_feot_enabled
                      "
                      class="no-header no-border"
                    >
                      <div class="block-labels">
                        <label class="mb-0 mt-1">
                          Choose your desired time window:
                        </label>
                        <label class="radio" *ngFor="let pace of feotPacings">
                          <div class="feotPacing">
                            <input
                              class="feotPacingRadio"
                              type="radio"
                              [value]="pace | lowercase"
                              formControlName="pacing"
                              (change)="updateFeotPacing()"
                              psUiActivityLog
                              logMessage="FEOT_STATUS"
                              logMessage="FEOT_STATUS"
                              logListenEvent="change"
                              [logSurveyId]="surveyId"
                              [logMetadata]="{
                                from: featureStatus(
                                  !form.value.is_feot_enabled
                                ),
                                to: featureStatus(form.value.is_feot_enabled),
                                completes: feotFields.feotQuantity,
                                kind: isClickSurvey ? 'click' : 'complete',
                                window:
                                  (isCustomPacingText
                                    ? feotPaceSingular()
                                    : 'day'
                                  ) | lowercase,
                                total: feotFields.feotRemainingTime
                              }"
                            />
                            {{ pace }}
                          </div>
                        </label>
                        <label class="mb-0 mt-1">
                          Choose your desired interval:
                        </label>
                        <label>
                          Every
                          <input
                            type="number"
                            formControlName="interval"
                            class="d-inline-block inputlaunchQty input-pacing"
                            maxlength="2"
                            psUiInputRestriction="[0-9]"
                            oninput="if(this.value.length>2){ this.value = this.value.slice(0,2) } else if (this.value.includes('-')) { this.value = 0 }"
                            (change)="updateFeotPacingInterval()"
                          />
                          <span [ngSwitch]="form.value.feot.pacing">
                            <ng-container *ngFor="let pace of feotPacings">
                              <span *ngSwitchCase="pace | lowercase">
                                {{ feotPaceFormat(pace) }}
                              </span>
                            </ng-container>
                            <span *ngSwitchDefault>
                              {{ feotPaceFormat('Days') }}
                            </span>
                          </span>
                        </label>
                      </div>
                    </ps-ui-accordion-section>
                  </ps-ui-accordion>
                </ps-ui-accordion-section>
              </ps-ui-accordion>
            </div>
          </ng-template>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin' ||
                userDetails.operatorAcssLvls === 'serviceOperator';
              else feotContent
            "
          >
            <ng-container *ngTemplateOutlet="feotTemplate"></ng-container>
          </div>
          <ng-template #feotContent>
            <div *psUiConfigEnabled="'enableFeot'">
              <ng-container *ngTemplateOutlet="feotTemplate"></ng-container>
            </div>
          </ng-template>

          <ng-template #qbpTemplate>
            <div
              class="sectionMargin"
              [ngClass]="{ 'aida-enabled': form.value.is_aida_enabled }"
            >
              <label class="text-uppercase">Quota-Based Pricing</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span
                    >When Quota-Based Pricing (QBP) is enabled for a survey,
                    CPI's may be independently modified.</span
                  >
                  <br />
                  <span>
                    NOTE:
                    <br />
                    * In the event of a nested quota, it is auto-selected for
                    the QBP quota.
                    <br />
                    * Once a survey has been launched with QBP enabled, it is
                    not possible to disable QBP or modify qualifications.
                    <br />
                    * QBP requires that the LIVE URL be in a correct format:
                    https://...
                  </span>
                </p>
              </div>
              <ps-ui-aida-feature-unavailable-tooltip
                [isAidaEnabled]="form.value.is_aida_enabled"
                class="ms-2"
              ></ps-ui-aida-feature-unavailable-tooltip>

              <ps-ui-qbp-feature-unavailable-tooltip
                [show]="!form.value.is_aida_enabled && isMultiNestingAvailable"
                reason="QBP feature is not available in a survey with multiple quotas nesting"
              >
              </ps-ui-qbp-feature-unavailable-tooltip>

              <div class="d-flex align-items-center">
                <span class="selectBtn">off</span>
                <ps-ui-slider
                  id="qbp"
                  [ngClass]="{
                    slider_on: this.form.controls.qbp.enable
                  }"
                  (selectedChange)="updateQBPToggle()"
                  [(selected)]="form.value.qbp.enable"
                  [disabled]="
                    isQbpSliderDisabled ||
                    !!form.value.is_aida_enabled ||
                    isMultiNestingAvailable
                  "
                  psUiGtagEvent
                  trackOn="change"
                  action="qbp"
                  category="Survey_Launch_Edit"
                  [params]="{ event_label: 'QBP' }"
                  psUiActivityLog
                  logMessage="QUOTA_BASED_PRICING_STATUS"
                  logListenEvent="change"
                  [logSurveyId]="surveyId"
                  [logMetadata]="{
                    from: featureStatus(!form.value.qbp.enable),
                    to: featureStatus(form.value.qbp.enable)
                  }"
                >
                </ps-ui-slider>
                <span class="selectBtn">on</span>
              </div>
              <div
                *ngIf="this.form.value.qbp.enable"
                class="margin-l30 quotapricing_options"
              >
                <p>Select one (1) quota to apply QBP</p>
                <ul *ngFor="let quota of qbpSelectionQuotas">
                  <input
                    type="radio"
                    class="qbp-radio"
                    formControlName="qbpSelectedQuota"
                    name="qbpSelectedQuota"
                    (change)="setQbpSelection(quota)"
                    [value]="quota"
                    [attr.disabled]="
                      isQbpSliderDisabled &&
                      this.form.controls.qbpSelectedQuota.value.name !==
                        quota.name
                        ? true
                        : null
                    "
                    [ngClass]="{ range: isQbpSliderDisabled }"
                  />
                  <label
                    [ngClass]="{
                      quotapricing_name:
                        quota.name ===
                        this.form.controls.qbpSelectedQuota.value.name
                    }"
                    >{{ quota.name }}
                  </label>
                </ul>
              </div>
            </div>
          </ng-template>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin' ||
                userDetails.operatorAcssLvls === 'serviceOperator';
              else qbpContent
            "
          >
            <ng-container *ngTemplateOutlet="qbpTemplate"></ng-container>
          </div>
          <ng-template #qbpContent>
            <div *psUiConfigEnabled="'qbp'">
              <ng-container *ngTemplateOutlet="qbpTemplate"></ng-container>
            </div>
          </ng-template>

          <ng-template #qlcTemplate>
            <div class="sectionMargin">
              <label>QUOTA-LEVEL COMPLETE</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span>
                    When quota-level complete (QLC) is enabled for a survey.
                    Quota Id will be mapped for each quota.
                  </span>
                </p>
              </div>
              <div class="d-flex align-items-center">
                <span class="selectBtn">off</span>
                <ps-ui-slider
                  id="qlc"
                  [ngClass]="{
                    slider_on: form.controls.qlc.enable
                  }"
                  (selectedChange)="updateQLCToggle()"
                  [(selected)]="form.value.qlc.enable"
                  [disabled]="isQlcSliderDisabled"
                  psUiGtagEvent
                  trackOn="change"
                  action="qlc"
                  category="Survey_Launch_Edit"
                  [params]="{ event_label: 'QLC' }"
                  psUiActivityLog
                  logMessage="QUOTA_LEVEL_COMPLETE"
                  logListenEvent="change"
                  [logSurveyId]="surveyId"
                  [logMetadata]="{
                    from: featureStatus(!form.value.qlc.enable),
                    to: featureStatus(form.value.qlc.enable)
                  }"
                >
                </ps-ui-slider>
                <span class="selectBtn">on</span>
              </div>
            </div>
          </ng-template>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin' ||
                userDetails.operatorAcssLvls === 'serviceOperator';
              else qlcContent
            "
          >
            <ng-container *ngTemplateOutlet="qlcTemplate"></ng-container>
          </div>
          <ng-template #qlcContent>
            <div *psUiConfigEnabled="'qlc'">
              <ng-container *ngTemplateOutlet="qlcTemplate"></ng-container>
            </div>
          </ng-template>
        </section>

        <section class="padding-added filter-audience">
          <label class="section launchLable">Filter Audience </label>

          <div *ngIf="isMcSvpSurvey" class="d-flex">
            <input
              id="sameFilterAudience"
              type="checkbox"
              class="form-check-input"
              (change)="
                toggleSameSettingsCheck(
                  'isSameFilterAudienceChecked',
                  !form.value.isSameFilterAudienceChecked
                )
              "
              [disabled]="isMcSvpSurvey"
              [checked]="form.value.isSameFilterAudienceChecked"
            />
            <label
              for="sameFilterAudience"
              class="lbl-view same-settings-check-txt"
            >
              {{ SAME_SETTINGS_TEXT.SINGLE_VIEW.FILTER_AUDIENCE_FEATURES }}
            </label>
            <ng-container
              *ngTemplateOutlet="sameSettingsTooltip"
            ></ng-container>
          </div>

          <div class="filterIncludeExcludePreRespondents">
            <div class="sectionMargin">
              <label *ngIf="!showIncludeToo">
                Exclude
                <span class="preview-respondent-text"
                  >Previous Respondents</span
                ></label
              >
              <label *ngIf="showIncludeToo"
                >Include/Exclude
                <span class="preview-respondent-text"
                  >Previous Respondents</span
                ></label
              >
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span
                    >To target specific respondents, use the toggle switch to
                    select "include" or "exclude", and upload a list of PSIDs.
                    Choosing "include" will limit survey participation to only
                    those on the uploaded list, while selecting "exclude" will
                    prevent those PSIDs from taking the survey.</span
                  ><br /><br /><span>
                    Please note that Marketplace will automatically remove any
                    Traffic Channels projects from the list of excluded
                    projects. Those PSIDs are stored in the ‘Parent’
                    project.".</span
                  >
                </p>
              </div>
              <div class="d-flex align-items-center">
                <div *ngIf="showIncludeToo">
                  <span class="selectBtn">Exclude </span>
                  <ps-ui-slider
                    id="entryLinks"
                    (selectedChange)="changeInclExcl($event ? 1 : 0)"
                    [disabled]="!manageEdit"
                    [selected]="form.value.incl_excl"
                    [ngClass]="{
                      slider_on: form.controls.incl_excl
                    }"
                    psUiActivityLog
                    logMessage="INCLUDE_EXCLUDE_STATUS"
                    logListenEvent="change"
                    [logSurveyId]="surveyId"
                    [logMetadata]="{
                      from: featureStatus(!form.value.incl_excl),
                      to: featureStatus(form.value.incl_excl)
                    }"
                  >
                  </ps-ui-slider>
                  <span class="selectBtn">Include</span>
                </div>
                <br />

                <div class="incl-excl" *ngIf="!inclExclBuyerUpload">
                  <a
                    class="text-decoration-underline"
                    [class.disabled-respondent-list]="surveyGroupingPSIDUpload"
                    href="javascript:void(0)"
                    (click)="fileUpload.click()"
                    >Upload Respondent List</a
                  >
                  <input
                    type="file"
                    [hidden]="true"
                    class="file-input"
                    accept=".csv, .xls, .xlsx"
                    (change)="onFileChange($event)"
                    #fileUpload
                    psUiGtagEvent
                    trackOn="change"
                    action="include_exclude_file"
                    category="Survey_Launch_Edit"
                    [params]="{ event_label: 'Include/Exclude Reflist' }"
                    psUiActivityLog
                    logMessage="INCLUDE_EXCLUDE_UPLOAD"
                    logListenEvent="change"
                    [logSurveyId]="surveyId"
                  />
                  <span class="position-static">|</span>
                  <a
                    class="text-decoration-underline"
                    [class.disabled-respondent-list]="surveyGroupingPSIDUpload"
                    href="../../../assets/templates/incl_excl.csv"
                    target="_self"
                    >Download Template</a
                  >
                </div>
                <div class="incl-excl" *ngIf="inclExclBuyerUpload">
                  <a
                    class="text-decoration-underline"
                    [class.disabled-respondent-list]="surveyGroupingPSIDUpload"
                    href="javascript:void(0)"
                    (click)="viewPSID()"
                    >View Respondent List</a
                  >
                  <span class="position-static">|</span>
                  <a
                    [class.disabled-respondent-list]="surveyGroupingPSIDUpload"
                    class="text-decoration-underline"
                    href="javascript:void(0)"
                    data-toggle="modal"
                    (click)="clearPSID()"
                    psUiActivityLog
                    logMessage="INCLUDE_EXCLUDE_CLEAR"
                    logListenEvent="click"
                    [logSurveyId]="surveyId"
                    [logMetadata]="{
                      from: featureStatus(!form.value.uniqBuyerEntryLinkFlag),
                      to: featureStatus(form.value.uniqBuyerEntryLinkFlag)
                    }"
                    >Clear Upload</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="filterIncludeExcludePreRespondents"
            *ngIf="enableFilteringByDate"
          >
            <div class="sectionMargin">
              <label> Filter By Date Range </label>

              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span
                    >Using the Date range allow the user to select automatically
                    a group of surveys. It works for Exclude and Include. In
                    both ways, the data range fetches all surveys closed in the
                    range selected and Excludes or Includes all participants of
                    the study as per Survey Grouping. After selecting the date
                    range, the system automatically adds the survey to the
                    survey grouping section below.</span
                  >
                </p>
              </div>
              <div class="form-group row date-range-project">
                <div
                  #dateRangeFilterRef
                  name="daterangeInput"
                  class="input-group"
                  [class.disabled-filter-by-date]="
                    surveyDatails.ps_survey_status !== surveyStatus.Draft ||
                    inclExclBuyerUpload
                  "
                  daterangepicker
                  [options]="filterByDatapickerOptions"
                  (applyDaterangepicker)="applyFilterDateRange($event)"
                  (cancelDaterangepicker)="cancelFilterDateRange()"
                  psUiActivityLog
                  logMessage="INCLUDE_EXCLUDE_DATE_FILTER"
                  logListenEvent="focusout"
                  [logSurveyId]="surveyId"
                >
                  <span class="form-control uneditable-input">
                    {{ filterDateRange.start | date : 'YYYY-MM-dd' }}
                    {{
                      filterDateRange.start && filterDateRange.end
                        ? ' - '
                        : 'Select date range'
                    }}
                    {{ filterDateRange.end | date : 'YYYY-MM-dd' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionMargin">
            <label>SURVEY GROUPING</label>
            <p
              style="font-size: 9px; margin-bottom: 0px"
              *ngIf="!inclExclDisable"
            >
              Exclude Respondents that have participated in previous surveys.
              Separate survey ID's by comma
            </p>
            <p
              style="font-size: 9px; margin-bottom: 0px"
              *ngIf="inclExclDisable"
            >
              Include Respondents that have participated in and completed the
              previous surveys. Separate survey ID's by comma
            </p>
            <textarea
              class="form-control"
              formControlName="survey_grouping"
              (blur)="checkWarnGroupingRemoval()"
              (change)="setSurveyGrouping()"
              name="surveyGrouping"
              placeholder="1001,1002,1003..."
              rows="5"
              psUiActivityLog
              logMessage="SURVEY_GROUP_UPLOAD"
              logListenEvent="change"
              [logSurveyId]="surveyId"
            ></textarea>
            <a
              *ngIf="enableFilteringByDate && surveyGroupingPSIDUpload"
              class="text-decoration-underline"
              href="javascript:void(0)"
              (click)="viewIncludePSID()"
              >View Respondent List</a
            >
          </div>

          <ng-template #externalSurveyIdTemplate>
            <div class="sectionMargin">
              <label>EXTERNAL SURVEY ID</label>
              <input
                type="text placeholder="
                name="survey_external_id"
                formControlName="survey_external_id"
                (keyup)="
                  updatePayload({
                    survey_external_id: this.form.value.survey_external_id
                  })
                "
                psUiActivityLog
                logMessage="EXTERNAL_SURVEY_ID"
                logListenEvent="change"
                [logSurveyId]="surveyId"
                [logMetadata]="{
                  externalSurveyId:
                    this.form.value.survey_external_id || 'empty'
                }"
                class="form-control survey-style width100"
              />
            </div>
          </ng-template>

          <div
            *ngIf="
              userDetails.operatorAcssLvls === 'admin';
              else externalSurveyIdContent
            "
          >
            <ng-container
              *ngTemplateOutlet="externalSurveyIdTemplate"
            ></ng-container>
          </div>
          <ng-template #externalSurveyIdContent>
            <div *psUiConfigEnabled="'enableSurveyExternalId'">
              <ng-container
                *ngTemplateOutlet="externalSurveyIdTemplate"
              ></ng-container>
            </div>
          </ng-template>

          <div class="sectionMargin">
            <label class="section launchLable"> Email Features </label>

            <div *ngIf="isMcSvpSurvey || isTraditionalMcSurvey" class="d-flex">
              <input
                id="sameEmailFeatures"
                type="checkbox"
                class="form-check-input"
                (change)="
                  toggleSameSettingsCheck(
                    'isSameEmailFeaturesChecked',
                    !form.value.isSameEmailFeaturesChecked
                  )
                "
                [disabled]="isMcSvpSurvey"
                [checked]="form.value.isSameEmailFeaturesChecked"
              />
              <label
                for="sameEmailFeatures"
                class="lbl-view same-settings-check-txt"
              >
                {{
                  isMcSvpSurvey
                    ? SAME_SETTINGS_TEXT.SINGLE_VIEW.EMAIL_FEATURES
                    : SAME_SETTINGS_TEXT.TRADITIONAL_VIEW.EMAIL_FEATURES
                }}
              </label>
              <ng-container
                *ngTemplateOutlet="sameSettingsTooltip"
              ></ng-container>
            </div>

            <label>SUBSCRIBER EMAIL</label>
            <div class="setting-info">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span
                  >You may add email addresses to this list to keep them
                  notified as your survey progresses through field. Add the
                  emails in this field, separated by a comma.</span
                >
              </p>
            </div>
            <textarea
              class="form-control"
              (keyup)="setSubscriberEmails()"
              formControlName="subscriber_emails"
              rows="3"
            ></textarea>
          </div>

          <div class="sectionMargin" *ngIf="pmEmailFieldDisplay">
            <div class="d-flex">
              <label>INCLUDE PROJECT MANAGER EMAILS TO THE INVOICE EMAIL</label>
              <div class="setting-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <p>
                  <span
                    >Add the emails in this field, separated by a comma.</span
                  >
                </p>
              </div>
            </div>
            <textarea
              class="form-control"
              (keyup)="
                updatePayload({ pm_emails: form.value.pm_emails?.split(',') })
              "
              formControlName="pm_emails"
              rows="3"
            ></textarea>
          </div>

          <div class="sectionMargin">
            <label>MESSAGE TO SUPPLIERS</label>
            <div class="setting-info">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              <p>
                <span
                  >Some suppliers are able to receive additional
                  instructions.You may include those instructions below.</span
                >
              </p>
            </div>
            <textarea
              class="form-control"
              formControlName="buyer_message"
              (keyup)="
                updatePayload({ buyer_message: form.value.buyer_message })
              "
              rows="3"
            ></textarea>
          </div>
          <ng-container>
            <label
              *ngIf="showAdditionalSectionLabel"
              class="section launchLable"
            >
              Additional Features
            </label>
            <div
              class="sectionMargin projectManager"
              *ngIf="enableViewByPM || userType === 'operator'"
            >
              <label>
                <span *psUiHasRole="'operator'"> BUYER </span>
                PROJECT MANAGER
                <ng-container
                  *ngTemplateOutlet="automaticSameSettingsLabel"
                ></ng-container>
              </label>
              <ps-ui-select-dropdown
                [dropdownItems]="buyerProjectManagers"
                [field]="'name'"
                formControlName="bpm"
                labelNone="{{ buyerPmLabel }}"
                (selectedItem)="selectBuyerProjectManager($event)"
              >
              </ps-ui-select-dropdown>
            </div>
          </ng-container>
          <ng-container *psUiHasRole="'operator'">
            <div class="sectionMargin projectManager">
              <label>
                OPERATOR PROJECT MANAGER
                <ng-container
                  *ngTemplateOutlet="automaticSameSettingsLabel"
                ></ng-container>
              </label>
              <ps-ui-select-dropdown
                [dropdownItems]="operatorProjectManagers"
                [field]="'name'"
                formControlName="pm"
                labelNone="-- Assign Project Manager --"
                (selectedItem)="selectProjectManager($event)"
              >
              </ps-ui-select-dropdown>
            </div>
            <div class="sectionMargin">
              <label>
                CRM ID
                <ng-container
                  *ngTemplateOutlet="automaticSameSettingsLabel"
                ></ng-container>
              </label>
              <input
                type="text"
                formControlName="crmId"
                placeholder=""
                name="crmId"
                (keyup)="updatePayload({ crmId: form.value.crmId })"
                class="form-control survey-style width100"
              />
            </div>
            <div class="sectionMargin">
              <label>
                ASANA ID
                <ng-container
                  *ngTemplateOutlet="automaticSameSettingsLabel"
                ></ng-container>
              </label>
              <input
                type="text"
                formControlName="asanaId"
                placeholder=""
                name="asanaId"
                (keyup)="updatePayload({ asanaId: form.value.asanaId })"
                class="form-control survey-style width100"
              />
            </div>
          </ng-container>
        </section>
      </div>
    </div>

    <ng-template #automaticSameSettingsLabel>
      <span *ngIf="isTraditionalMcSurvey || isMcSvpSurvey">
        {{ AUTOMATIC_SAME_SETTINGS_TEXT }}
      </span>
    </ng-template>

    <ng-template #sameSettingsTooltip>
      <ng-container *ngIf="isMcSvpSurvey">
        <div class="setting-info same-settings-tooltip-container">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <p>
            <span> {{ SAME_SETTINGS_TOOLTIP_TEXT.SINGLE_VIEW }} </span>
          </p>
        </div>
      </ng-container>
    </ng-template>
  </form>
  <ps-ui-right-slider-window
    [surveyDetails]="surveyDatails"
    [surveyPayload]="surveyPayload"
  ></ps-ui-right-slider-window>
</div>
<ps-ui-footer
  [class.d-none]="isInsight"
  [isInsight]="isInsight"
  [buttonStatus]="footerButtonStatus"
  [surveyPayload]="surveyPayload"
  [currentPage]="'LAUNCH'"
  [buttonStatus]="2"
  [billingRuleExample]="billingRules?.example"
  [templateResponse]="selectedTemplateResponse"
  (updatedTemplate)="selectedTemplateResponse = $event"
></ps-ui-footer>
